import React, { memo } from 'react';
import styles from './AddressItem.module.scss';
import { Form } from 'antd';
import DropdownSelect from '../../../../components/dropdownSelect';
import { getRenderControl } from '../../../../components/SingleControlCustom/getRenderControl';
import useRequestStreets from '../../../../queries/useRequestStreets';
import useRequestHouses from '../../../../queries/useRequestHouses';
import useRequestAddresses from '../../../../queries/useRequestAddresses';
import useAddressField from '../../hooks/useAddressField';
import {
  getDocOptionsSelect,
  getDocOptionsSelectStreet,
} from '../../utils/getDocOptionsSelect';
import { ReactComponent as DeleteIcon } from '../../../../resource/DeleteIcon.svg';

const AddressItem = memo(({ form, index, allowDelete, deleteItem }) => {
  const { getFieldDecorator } = form;

  const {
    streetValue,
    houseValue,
    flatValue,
    handleStreetChange,
    handleHouseChange,
  } = useAddressField(form, index);

  const { data: streets = [], isFetching: isCitiesFetching } =
    useRequestStreets({ staleTime: Infinity });

  const { data: houses = [], isFetching: isHousesFetching } = useRequestHouses(
    streetValue,
    {
      enabled: Boolean(streetValue),
    }
  );

  const { data: flats = [], isFetching: isFlatsFetching } = useRequestAddresses(
    houseValue,
    {
      enabled: Boolean(houseValue && streetValue),
    }
  );

  const streetsOptions = streets?.length
    ? getDocOptionsSelectStreet(streets)
    : [];
  const housesOptions =
    houses?.length && !!streetValue ? getDocOptionsSelect(houses) : [];
  const flatsOptions =
    flats?.length && !!houseValue ? getDocOptionsSelect(flats, true) : [];

  return (
    <div className={styles.container}>
      <div className={styles.root}>
        <Form.Item className={styles.item}>
          {getFieldDecorator(`streetIds[${index}]`)(
            <DropdownSelect
              disabled={isCitiesFetching}
              loading={isCitiesFetching}
              multiple={false}
              onChange={handleStreetChange}
              options={streetsOptions}
              renderControl={getRenderControl({
                options: streetsOptions,
                isClear: true,
                value: streetValue,
                placeholder: 'Выберите улицу',
                onClearClick: () => handleStreetChange(undefined),
              })}
            />
          )}
        </Form.Item>
        <Form.Item className={styles.item}>
          {getFieldDecorator(`houseIds[${index}]`, {
            rules: [
              {
                required: !!streetValue,
                message: 'Пожалуйста, укажите дом',
              },
            ],
          })(
            <DropdownSelect
              key={`house-select-${index}-${streetValue}-${housesOptions.length}`}
              disabled={isHousesFetching}
              loading={isHousesFetching}
              multiple={false}
              onChange={handleHouseChange}
              options={housesOptions}
              renderControl={getRenderControl({
                options: housesOptions,
                isClear: false,
                value: houseValue,
                placeholder: 'Дом',
              })}
            />
          )}
        </Form.Item>
        <Form.Item className={styles.item}>
          {getFieldDecorator(`addressIds[${index}]`, {
            rules: [
              {
                required: !!streetValue,
                message: 'Пожалуйста, укажите помещение',
              },
            ],
          })(
            <DropdownSelect
              key={`house-select-${index}-${houseValue}-${flatsOptions.length}`}
              disabled={isFlatsFetching}
              loading={isFlatsFetching}
              multiple={false}
              options={flatsOptions}
              renderControl={getRenderControl({
                options: flatsOptions,
                isClear: false,
                value: flatValue,
                placeholder: 'Кв./офис',
              })}
            />
          )}
        </Form.Item>
      </div>
      {allowDelete && (
        <DeleteIcon
          style={{ cursor: 'pointer', fill: '#F93336' }}
          onClick={() => deleteItem(index)}
        />
      )}
    </div>
  );
});

export default AddressItem;
